import ajax from "./ajax";

export function getPage(pageName) {
  return ajax(`/pages?PageSearch[url_slug]=${pageName}`);
}
